module.exports = __webpack_public_path__ + "static/media/UC Compound Golf Still 02.RGB_color.0000.98eedcce.webp";